import { HttpErrorResponse } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CustomSnackbarComponent, ModalSelecaoVolumesComponent } from 'src/app/@shared/components';
import { ModalErroColetorComponent } from 'src/app/@shared/components/modal-erro-coletor/modal-erro-coletor.component';
import { TipoConsultaBarcode } from 'src/app/@shared/enum/tipoConsultaBarcode';
import { detectar_mobile } from 'src/app/@shared/helpers/vesta-helpers';
import { VolumeFae } from 'src/app/@shared/models/fae/gerar-pre-fae/fae.model';
import { ObjetoGridVolumes, ObjGridVolCols } from 'src/app/@shared/models/selecao-volumes/objeto-grid-volumes.model';
import { BarcodeListarLoteResponse, BarcodeListarRequest, CodigoBarras, CodigoBarrasVolume, SelecaoVolumes, Volume } from 'src/app/@shared/models/selecao-volumes/selecao-volumes.model';
import { FaeService } from '../fae/fae.service';
import { PlayAudiosService } from 'src/app/services/audios/playAudios.service';

export interface PedidoVolume {
  pedidoId: number;
  pedEtiqueta: number;
  qtdVolume?: number;
}

type ModalSelecaoVolumeCallback = (selecao: SelecaoVolumes) => any;
@Injectable({
  providedIn: 'root'
})
export class ConsultaBarcodeMultiploService {

  public onPackageSelected: EventEmitter<CodigoBarras | any> = new EventEmitter();
  public updateLoading: EventEmitter<boolean> = new EventEmitter();
  public isMobile: boolean = false;

  constructor(
    public faeService: FaeService,
    public dialog: MatDialog,
    public snackBar: CustomSnackbarComponent,
    private playAudiosService: PlayAudiosService
  ) {
    this.isMobile = detectar_mobile();

  }

  removeExistentes(vols: PedidoVolume[], listagem: BarcodeListarLoteResponse[]) {
    //quando consultar pelo código de barras e possuir somente um volume, permitir seguir para exibir a mensagem de que item já está na grid;
    if (listagem?.length === 1) {
      let check_origin = ["PEDETIQUETA"];
      let check_find = listagem[0].origens?.find(o => check_origin.includes(o));
      if (check_find && listagem[0].pedido.volumes?.length == 1) return listagem;
    }

    const to_change = listagem?.filter(p => p.sucesso).filter(({ pedido: { pedidoId, volumes } }) =>
      vols.find((pedVolume) => pedVolume.pedidoId === pedidoId && volumes.map(({ pedEtiqueta }) => pedEtiqueta).includes(pedVolume.pedEtiqueta)
      )
    );

    to_change?.forEach(tc => {
      tc.pedido.volumes = tc.pedido.volumes.filter(v =>
        !vols.find
          (
            ({ pedidoId, pedEtiqueta }) => pedidoId === tc.pedido.pedidoId && pedEtiqueta === v.pedEtiqueta
          )
      )
    });

    return listagem?.filter(p => p.sucesso);
  }


  async modalSelecaoVolume(
    barcodeLista: string[],
    objetoVolume: BarcodeListarLoteResponse[],
    exibirColunas: ObjGridVolCols,
    callbackSelecao: ModalSelecaoVolumeCallback,
    tipo?: TipoConsultaBarcode
  ) {
    const dialogRef = this.dialog.open(ModalSelecaoVolumesComponent, {
      disableClose: true,
      width: '800px',
      data: {
        objetoVolume,
        codigoBarras: barcodeLista,
        exibirColunas,
        tipo
      },
      panelClass: 'modal-selecao-volume-panel'
    })
    await dialogRef.afterClosed().toPromise().then((selecaoVolume) => callbackSelecao(selecaoVolume));
  }


  async modalSelecaoVolumeVolume(
    barcodeLista: string[],
    objetoVolume: VolumeFae[],
    exibirColunas: ObjGridVolCols,
    callbackSelecao: ModalSelecaoVolumeCallback,
    tipo?: TipoConsultaBarcode
  ) {
    const dialogRef = this.dialog.open(ModalSelecaoVolumesComponent, {
      disableClose: true,
      width: '800px',
      data: {
        objetoVolume,
        codigoBarras: barcodeLista,
        exibirColunas,
        tipo
      },
      panelClass: 'modal-selecao-volume-panel'
    })
    await dialogRef.afterClosed().toPromise().then((selecaoVolume) => callbackSelecao(selecaoVolume));
  }

  public consultarBarcodeRetornoFae(
    barcode,
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    alpha
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.CONSULTA_FAE,
      alpha
    };
    this.faeService.barcodeListarMultiplo(obj).subscribe(
      (response: BarcodeListarLoteResponse[]) => {
        response.forEach(async a => {
          if (!a.sucesso) {
            this.mostrarErro(`${a.barCodeVol} - ${a.mensagem}`)
          } else {
            await this.processarBarcodeRetorno(
              [a],
              objetoGrid,
              a.barCodeVol,
              this.consultarBarcodeRetornoFae
            )
          }
        });
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcodeGerarPreFae(
    barcode,
    objetoGrid: ObjetoGridVolumes<CodigoBarras>
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.CONSULTA_FAE
    };
    this.faeService.barcodeListarMultiplo(obj).subscribe(
      (response: BarcodeListarLoteResponse[]) => {
        let mensagens = [];
        response.forEach(async a => {
          if (!a.sucesso) {
            mensagens.push(`${a.barCodeVol} - ${a.mensagem}`);

          } else {
            await this.processarBarcode(
              [a],
              objetoGrid,
              a.barCodeVol,
              this.consultarBarcodeGerarPreFae
            )
          }
        });

        if (mensagens.length > 0) {
          this.playAudiosService.playAudioError();
          this.mostrarErro(mensagens[0]);
          return;
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.playAudiosService.playAudioError();
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      .add(() => this.updateLoading.emit(false)
      )
  }


  public consultarBarcodeVolumeGerarPreFae(
    barcode,
    objetoGrid: ObjetoGridVolumes<CodigoBarrasVolume>,
    isExclusao: boolean = false
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.CONSULTA_FAE
    };
    this.faeService.barcodeListaVolume(obj).subscribe(
      async (response: VolumeFae[]) => {
        let mensagens = [];
        await this.processarBarcodeVolume(
          response,
          objetoGrid,
          barcode,
          this.consultarBarcodeVolumeGerarPreFae,
          isExclusao
        )
        // response.forEach(async a => {

        //   await this.processarBarcodeVolume(
        //     [a],
        //     objetoGrid,
        //     a.barCodeVol,
        //     this.consultarBarcodeVolumeGerarPreFae
        //   )

        // });

        if (mensagens.length > 0) {
          this.playAudiosService.playAudioError();
          this.mostrarErro(mensagens[0]);
          return;
        }
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.playAudiosService.playAudioError();
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      // .add(() => this.updateLoading.emit(false)
      // )
  }

  async processarBarcodeRetorno(
    response: BarcodeListarLoteResponse[],
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    barcode,
    consultarBarCodeUnitario
  ) {
    const vols = objetoGrid.grid.reduce(
      (arr: PedidoVolume[], { pedidoId, volumes }) => {
        volumes.forEach(v => arr.push({
          pedidoId,
          pedEtiqueta: v.pedEtiqueta
        })); return arr;
      }, []);
    let pedidosParaInserir = response.map(x => {
      return x.pedido.volumes.map(y => ({
        pedEtiqueta: y.pedEtiqueta, pedidoId: x.pedido.pedidoId
      }))
    });
    let pedidosInseridos = vols.filter(y => pedidosParaInserir[0].map(x => x.pedEtiqueta).includes(y.pedEtiqueta));
    // let pedidosParaInserir = response.map(x => x.pedido.pedidoId );
    // let pedidosInseridos = vols.filter(y => pedidosParaInserir.includes(y.pedidoId && y.pedEtiqueta));
    if (pedidosInseridos.length > 0) {
      debugger;
      this.playAudiosService.playAudioError();
      this.abrirModalErro('Pedido já bipado');
      return;
      // this.openSnackBar('Pedido já bipado', 'OK', 3000, 'danger-snackbar');
    }

    const filtrado = this.removeExistentes(vols, response);
    if (filtrado?.length) {
      const estruturado = filtrado.reduce(
        (estrut, { pedido }) => {
          estrut[pedido.pedidoId] = [
            ...new Set([...(estrut[pedido.pedidoId] || []),
            ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
            ])];
          return estrut;
        }, {});

      var exibe_modal = Object.keys(estruturado).length > 1;
      if (!exibe_modal)
        for (var it in estruturado) {
          if (estruturado[it] && estruturado[it].length > 1) {
            exibe_modal = true;
            break;
          }
        }

      if (exibe_modal) {
        await this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
          (result: SelecaoVolumes) => {
            if (!result) return;

            if (result?.volumeSelecionado) {
              let volumeSelecionado = result?.volumeSelecionado;
              volumeSelecionado.pedidoId = result.pedido.pedidoId;
              this.onPackageSelected.emit(volumeSelecionado);
            } else {
              //busca por NRT para trazer os volumes
              consultarBarCodeUnitario(result.pedido.pedidoId, objetoGrid);
            }
          });
      } else {

        const pedidoId = Object.keys(estruturado)[0];
        const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
        let check_origin = ["PEDETIQUETA", "NRT"];
        let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
        if (!pedidoEtiqueta && !check_find) {
          consultarBarCodeUnitario(pedidoId, objetoGrid);
        }
        else {
          let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
          if (volumeSelecionado) {
            volumeSelecionado.pedidoId = parseInt(pedidoId);
            volumeSelecionado.qtdVolume = filtrado[0]?.pedido?.qtdVolume;
          }
          this.onPackageSelected.emit(volumeSelecionado);
        }
      }
    } else {
      this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
    }
  }

  async processarBarcode(
    response: BarcodeListarLoteResponse[],
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    barcode,
    consultarBarCodeUnitario
  ) {
    const vols = objetoGrid.grid.reduce(
      (arr: PedidoVolume[], { pedidoId, volumes }) => {
        volumes.forEach(v => arr.push({ pedidoId, pedEtiqueta: v.pedEtiqueta })); return arr;
      }, []);
      let pedidosParaInserir = response.map(x => {
        return x.pedido.volumes.map( y => ({
           pedEtiqueta: y.pedEtiqueta, pedidoId: x.pedido.pedidoId
        }))
      });
      let pedidosInseridos = vols.filter(y => pedidosParaInserir[0].map(x => x.pedEtiqueta).includes(y.pedEtiqueta));
      // let pedidosParaInserir = response.map(x => x.pedido.pedidoId );
      // let pedidosInseridos = vols.filter(y => pedidosParaInserir.includes(y.pedidoId && y.pedEtiqueta));

      let unico = true;
      pedidosParaInserir.forEach(x => {
        if(x.length > 1){
          unico = false;
          return;
        }
      })
      if(pedidosInseridos.length > 0 && unico){   
        debugger;     
        this.playAudiosService.playAudioError();
        this.abrirModalErro('Pedido já bipado');
        return;
      }

    const filtrado = this.removeExistentes(vols, response);
    if (filtrado?.length) {
      const estruturado = filtrado.reduce(
        (estrut, { pedido }) => {
          estrut[pedido.pedidoId] = [
            ...new Set([...(estrut[pedido.pedidoId] || []),
            ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
            ])];
          return estrut;
        }, {});

      var exibe_modal = Object.keys(estruturado).length > 1;

      if (!exibe_modal)
        for (var it in estruturado) {
          if (estruturado[it] && estruturado[it].length > 1) {
            exibe_modal = true;
            break;
          }
        }
      if (exibe_modal) {
        await this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
          (result: string | SelecaoVolumes) => {
            if (result === 'cancel') return;

            if (typeof result !== 'string') {
              if (result?.volumeSelecionado) {
                let volumeSelecionado = result?.volumeSelecionado;
                volumeSelecionado.pedidoId = result.pedido.pedidoId;

                var codigoBarras: CodigoBarras = {

                  pedidoId: result.pedido.pedidoId,
                  pedEtiqueta: result.volumeSelecionado.pedEtiqueta,
                  manifestoTransfID: result.pedido.manifTransfID,
                  codBarra: result.volumeSelecionado.barCodeVol,
                  volumes: [],
                  qtdVolume: result.pedido.qtdVolume,
                };
                codigoBarras.volumes.push(result.volumeSelecionado)

                this.onPackageSelected.emit(codigoBarras);
              } else {
                //busca por NRT para trazer os volumes
                consultarBarCodeUnitario(result.pedido.pedidoId, objetoGrid);
              }
            }
          });
      } else {
        const pedidoId = Object.keys(estruturado)[0];
        const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
        let check_origin = ["PEDETIQUETA", "NRT"];
        let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
        if (!pedidoEtiqueta && !check_find) {
          consultarBarCodeUnitario(pedidoId, objetoGrid);
        }
        else {
          const volumeSelecionado = filtrado[0]?.pedido;
          if (volumeSelecionado) {
            volumeSelecionado.qtdVolume = filtrado[0]?.pedido?.qtdVolume;
            volumeSelecionado.pedidoId = parseInt(pedidoId);
          }
          this.onPackageSelected.emit(volumeSelecionado);
        }
      }
    } else {
      this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
      // this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
    }
  }



  async processarBarcodeVolume(
    response: VolumeFae[],
    objetoGrid: ObjetoGridVolumes<CodigoBarrasVolume>,
    barcode,
    consultarBarCodeUnitario,
    isExclusao: boolean = false
  ) {

    let pedEtiquetas = response.map(x => {
      return x.pedEtiqueta
    });
    let pedidosInseridos = pedEtiquetas.filter(x => objetoGrid.grid.map(y => y.pedEtiqueta).includes(x));
    let pedidosParaInserir = pedEtiquetas.filter(x => !objetoGrid.grid.map(y => y.pedEtiqueta).includes(x));

    // let pedidosInseridos = objetoGrid.grid.filter(y => pedEtiquetas.includes(y.pedEtiqueta));
    if (pedidosInseridos.length > 0 && response.length == 1 && !isExclusao) {
      this.playAudiosService.playAudioError();
      this.abrirModalErro('Pedido já bipado');
      this.updateLoading.emit(false);
      return;
    }
    let pedidosFiltrado = [];
    if(!isExclusao){
      pedidosFiltrado = response.filter(x =>  pedidosParaInserir.includes(x.pedEtiqueta));
    } else {
      pedidosFiltrado = response.filter(x =>  pedidosInseridos.includes(x.pedEtiqueta));
    }
    if (pedidosFiltrado?.length) {
      var exibe_modal = pedidosFiltrado.length > 1;
      if (exibe_modal) {
        var pedidosAgrupados = pedidosFiltrado.reduce((prev, curr, i, array) => {
          if (prev && (prev.length == 0 || prev.filter(x => x.pedido.pedidoId == curr.pedidoId).length === 0)) {
            prev.push(
              {
                pedido: {
                  pedidoId: curr.pedidoId,
                  volumes: array.filter(x => x.pedidoId == curr.pedidoId)
                },

              }
            )
          }
          return prev;
        }, []);

        await this.modalSelecaoVolumeVolume(barcode, pedidosAgrupados, objetoGrid.showCols,
          (result: string | SelecaoVolumes) => {
            if (result === 'cancel') {
              this.updateLoading.emit(false);
              return;
            }

            if (typeof result !== 'string') {
              if (result?.volumeSelecionado) {
                let volumeSelecionado = result?.volumeSelecionado;
                volumeSelecionado.pedidoId = result.pedido.pedidoId;
                if (!isExclusao && pedidosInseridos.find(x => x == result.volumeSelecionado.pedEtiqueta)) {
                  this.playAudiosService.playAudioError();
                  this.abrirModalErro('Volume já bipado');
                  this.updateLoading.emit(false);
                  return;
                }

                var codigoBarras: CodigoBarrasVolume = {

                  pedidoId: result.pedido.pedidoId,
                  pedEtiqueta: result.volumeSelecionado.pedEtiqueta,
                  manifestoTransfID: result.pedido.manifTransfID,
                  codBarra: response.find(x => x.pedEtiqueta == result.volumeSelecionado.pedEtiqueta).barcode,
                  volumes: [],
                  qtdVolume: result.pedido.qtdVolume,
                  totalVolumes: response.find(x => x.pedEtiqueta == result.volumeSelecionado.pedEtiqueta).totalVolumes,
                  identificador: response.find(x => x.pedEtiqueta == result.volumeSelecionado.pedEtiqueta).identificador
                };
                // codigoBarras.volumes.push(result.volumeSelecionado)

                this.onPackageSelected.emit(codigoBarras);
              } else {
                //busca por NRT para trazer os volumes
                consultarBarCodeUnitario(result.pedido.pedidoId, objetoGrid);
              }
            }
          });
      } else {
        const pedidoId = pedidosFiltrado[0].pedidoId;
        const pedidoEtiqueta = pedidosFiltrado[0].pedEtiqueta;
        // let check_origin = ["PEDETIQUETA", "NRT"];
        // let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
        if (!pedidoEtiqueta) {
          consultarBarCodeUnitario(pedidoId, objetoGrid);
        }
        else {
          const volumeSelecionado = pedidosFiltrado[0];
          // if (volumeSelecionado) {
          //   volumeSelecionado.qtdVolume = filtrado[0]?.pedido?.qtdVolume;
          //   volumeSelecionado.pedidoId = parseInt(pedidoId);
          // }
          this.onPackageSelected.emit(volumeSelecionado);
        }
      }
    } else {
      if(!isExclusao){

        this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
      } else {
        this.mostrarErro('Pedido não encontrado na Pré-FAE para ser removido');
      }
      this.updateLoading.emit(false);
      // this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
    }
  }

  public consultarBarcodeAreaTransfMDT(barcode, objetoGrid: ObjetoGridVolumes<any>, alpha?: string) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.MDT_GERAR,
    };
    this.faeService.barcodeListarMultiplo(obj).subscribe(
      (response: BarcodeListarLoteResponse[]) => {
        let mensagens = [];
        response.forEach(async a => {
          if (!a.sucesso) {
            mensagens.push(`${a.barCodeVol} - ${a.mensagem}`);
          } else {
            await this.consultaBarCodeAreaTransfProcessMDT(
              [a],
              objetoGrid,
              a.barCodeVol,
              this.consultarBarcodeAreaTransfMDT
            )
          }
        });
        this.snackBar.open(mensagens, 'Ok', 2000, 'danger-snackbar');
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  public consultarBarcodeAreaTransfMT(barcode, objetoGrid: ObjetoGridVolumes<any>, alpha?: string) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.GERACAO_MANIFESTO_TRANSFERENCIA,
    };
    this.faeService.barcodeListarMultiplo(obj).subscribe(
      (response: BarcodeListarLoteResponse[]) => {
        let mensagens = [];
        response.forEach(async a => {
          if (!a.sucesso) {
            mensagens.push(`${a.barCodeVol} - ${a.mensagem}`);
          } else {
            await this.consultaBarCodeAreaTransfProcessMT(
              [a],
              objetoGrid,
              a.barCodeVol,
              this.consultarBarcodeAreaTransfMT
            )
          }
        });
        this.mostrarErro(mensagens[0]);
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  async consultaBarCodeAreaTransfProcessMT(response: BarcodeListarLoteResponse[],
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    barcode,
    consultarBarCodeUnitario) {
    const vols = objetoGrid.grid.reduce(
      (arr: PedidoVolume[], { pedidoId, volumes }) => {
        volumes.forEach(v => arr.push({
          pedidoId,
          pedEtiqueta: v.pedEtiqueta
        })); return arr;
      }, []);
    const filtrado = this.removeExistentes(vols, response);
    if (filtrado?.length) {
      const estruturado = filtrado.reduce(
        (estrut, { pedido }) => {
          estrut[pedido.pedidoId] = [...new Set([
            ...(estrut[pedido.pedidoId] || []),
            ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
          ])];
          return estrut;
        }, {});
      const pedidoId = Object.keys(estruturado)[0];
      const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
      if (!pedidoEtiqueta) consultarBarCodeUnitario(pedidoId, objetoGrid);
      else {
        let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
        if (volumeSelecionado) {
          volumeSelecionado.pedidoId = parseInt(pedidoId);
          volumeSelecionado.flgControlaCapacidade = filtrado[0].pedido.flgControlaCapacidade;
        }

        this.onPackageSelected.emit(volumeSelecionado);
      }
    } else {
      this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
    }
  }

  async consultaBarCodeAreaTransfProcessMDT(response: BarcodeListarLoteResponse[],
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    barcode,
    consultarBarCodeUnitario) {
    const vols = objetoGrid.grid.reduce(
      (arr: PedidoVolume[], { pedidoId, volumes }) => {
        volumes.forEach(v => arr.push({
          pedidoId,
          pedEtiqueta: v.pedEtiqueta
        })); return arr;
      }, []);
    const filtrado = this.removeExistentes(vols, response);
    if (filtrado?.length) {
      const estruturado = filtrado.reduce(
        (estrut, { pedido }) => {
          estrut[pedido.pedidoId] = [...new Set([
            ...(estrut[pedido.pedidoId] || []),
            ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
          ])];
          return estrut;
        }, {});
      const pedidoId = Object.keys(estruturado)[0];
      const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
      if (!pedidoEtiqueta) consultarBarCodeUnitario(pedidoId, objetoGrid);
      else {
        const volumeSelecionado = filtrado[0]?.pedido;
        if (volumeSelecionado) {
          volumeSelecionado.qtdVolume = filtrado[0]?.pedido?.qtdVolume;
          volumeSelecionado.pedidoId = parseInt(pedidoId);
        }
        this.onPackageSelected.emit(volumeSelecionado);
      }
    } else {
      this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
    }
  }

  public consultarBarcodeMDT(
    barcode,
    objetoGrid: ObjetoGridVolumes<CodigoBarras>
  ) {
    const obj: BarcodeListarRequest = {
      barcode,
      tipoConsulta: TipoConsultaBarcode.MDT_GERAR
    };
    this.faeService.barcodeListarMultiplo(obj).subscribe(
      (response: BarcodeListarLoteResponse[]) => {
        let mensagens = [];
        response.forEach(async a => {
          if (!a.sucesso) {
            mensagens.push(`${a.barCodeVol} - ${a.mensagem}`);
          } else {
            await this.processarBarcodeMDT(
              [a],
              objetoGrid,
              a.barCodeVol,
              this.consultarBarcodeMDT
            )
          }
        });
        this.snackBar.open(mensagens, 'Ok', 2000, 'danger-snackbar');
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.mostrarErro('Erro ao consultar código de barras!');
        return;
      })
      .add(() => this.updateLoading.emit(false)
      )
  }

  async processarBarcodeMDT(
    response: BarcodeListarLoteResponse[],
    objetoGrid: ObjetoGridVolumes<CodigoBarras>,
    barcode,
    consultarBarCodeUnitario
  ) {
    const vols = objetoGrid.grid.reduce(
      (arr: PedidoVolume[], { pedidoId, volumes, qtdVolume }) => {
        volumes.forEach(v => arr.push({
          pedidoId,
          pedEtiqueta: v.pedEtiqueta,
          qtdVolume: v.qtdVolume
        })); return arr;
      }, []);

    // let pedidosParaInserir = response.map(x => x.pedido.pedidoId);
    let pedidosParaInserir = response.map(x => {
      return x.pedido.volumes.map(y => ({
        pedEtiqueta: y.pedEtiqueta, pedidoId: x.pedido.pedidoId
      }))
    })
    let pedidosInseridos = vols.filter(y => pedidosParaInserir[0].map(x => x.pedEtiqueta).includes(y.pedEtiqueta));
    // let pedidosInseridos = vols.filter(y => pedidosParaInserir.includes(y.pedidoId && y.pedEtiqueta));

    if (pedidosInseridos.length > 0) {
      debugger;
      this.playAudiosService.playAudioError();
      this.mostrarErro('Pedido já bipado');
      // this.abrirModalErro('Pedido já bipado');
      return;
    }

    const filtrado = this.removeExistentes(vols, response);
    if (filtrado?.length) {
      const estruturado = filtrado.reduce(
        (estrut, { pedido }) => {
          estrut[pedido.pedidoId] = [...new Set([
            ...(estrut[pedido.pedidoId] || []),
            ...(estrut[pedido.qtdVolume] || []),
            ...pedido.volumes.map(({ pedEtiqueta }) => pedEtiqueta)
          ])];
          return estrut;
        }, {});

      var exibe_modal = Object.keys(estruturado).length > 1;
      if (!exibe_modal)
        for (var it in estruturado) {
          if (estruturado[it] && estruturado[it].length > 1) {
            exibe_modal = true;
            break;
          }
        }

      if (exibe_modal) {
        await this.modalSelecaoVolume(barcode, filtrado, objetoGrid.showCols,
          (result: SelecaoVolumes) => {
            if (!result) return;

            if (result?.volumeSelecionado) {
              let volumeSelecionado = result?.volumeSelecionado;
              volumeSelecionado.pedidoId = result.pedido.pedidoId;
              volumeSelecionado.qtdVolume = result.pedido.qtdVolume;
              this.onPackageSelected.emit(volumeSelecionado);
            } else {
              //busca por NRT para trazer os volumes
              consultarBarCodeUnitario(result.pedido.pedidoId, result.pedido.qtdVolume, objetoGrid);
            }
          });
      } else {

        const pedidoId = Object.keys(estruturado)[0];
        const pedidoEtiqueta = estruturado[pedidoId]?.length ? estruturado[pedidoId][0] : null;
        let check_origin = ["PEDETIQUETA", "NRT"];
        let check_find = filtrado[0].origens.find(o => check_origin.includes(o));
        if (!pedidoEtiqueta && !check_find) {
          consultarBarCodeUnitario(pedidoId, objetoGrid);
        }
        else {
          let volumeSelecionado = filtrado[0]?.pedido?.volumes[0];
          if (volumeSelecionado) {
            volumeSelecionado.pedidoId = parseInt(pedidoId);
            volumeSelecionado.qtdVolume = filtrado[0]?.pedido?.qtdVolume;
          }
          this.onPackageSelected.emit(volumeSelecionado);
        }
      }
    } else {
      this.mostrarErro('Não encontrei o pacote bipado. Tente bipar outro código de barras.');
      this.openSnackBar('Não encontrei o pacote bipado. Tente bipar outro código de barras.', 'OK', 3000, 'danger-snackbar');
    }
  }
 


  openSnackBar(message: string, action: string, duration: number, panelClass?: string): any {
    this.snackBar.open(message, action, duration, panelClass);
  }

  abrirModalErro(erro: string) {
    this.dialog.open(ModalErroColetorComponent, {
      width: '600px',
      height: '500px',
      data: { texto: erro, tempo: null },
      panelClass: 'error-modal-custom'
    });

  }

  mostrarErro(erro: string) {
    if (this.isMobile) {
      this.dialog.open(ModalErroColetorComponent, {
        width: '460px',
        height: '500px',
        data: { texto: erro, tempo: null },
        panelClass: 'error-modal-custom'
      });
    } else {
      this.openSnackBar(erro, 'OK', 5000, 'alert-snackbar')
    }

  }

}
